module.exports = __webpack_public_path__ + "img/logo-color.97ee91b9.svg";